<script setup>
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import { usePolicy } from 'dashboard/composables/usePolicy';

const emit = defineEmits(['add', 'import', 'export', 'dedup-export']);

const { t } = useI18n();
const { checkPermissions } = usePolicy();

const canManage = checkPermissions(['administrator', 'contact_manage']);
</script>

<template>
  <div class="flex items-center gap-2">
    <Button
      icon="i-lucide-plus"
      color="slate"
      variant="ghost"
      size="sm"
      :label="t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.ADD_CONTACT')"
      @click="emit('add')"
    />
    <Button
      v-if="canManage"
      icon="i-lucide-download"
      color="slate"
      variant="ghost"
      size="sm"
      :label="
        t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT')
      "
      @click="emit('import')"
    />
    <Button
      v-if="canManage"
      icon="i-lucide-upload"
      color="slate"
      variant="ghost"
      size="sm"
      :label="
        t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT')
      "
      @click="emit('export')"
    />
    <Button
      v-if="canManage"
      icon="i-lucide-filter"
      color="slate"
      variant="ghost"
      size="sm"
      label="去重导出"
      @click="emit('dedup-export')"
    />
  </div>
</template>
